export interface DeleteFuelSupplierContactRequest {
  ids: number[];
}
